export default "__VITE_ASSET__tbSHGTnj__"